import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col mt-6" };
const __default__ = {
    compatConfig: {
        COMPONENT_V_MODEL: false
    }
};
import { computed, nextTick, ref, watch } from 'vue';
import { useStore } from 'vuex';
import UserMultiSelect from '@/components/UserMultiSelect.vue';
import SelectedUser from '@/components/workspaces/SelectedUser.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'UserInput',
    props: {
        disallowExternalToWorkspace: { type: Boolean, default: false },
        disallowExternalToWorkspacePlaceholder: { type: Boolean, default: false },
        modelValue: null,
        searchTerm: null,
        size: null,
        users: null
    },
    emits: ['update:modelValue', 'update:searchTerm'],
    setup(__props, { emit }) {
        const props = __props;
        const isOverflown = ref(false);
        const selectedUsers = ref(null);
        watch(() => props.users, () => {
            nextTick(() => {
                const element = selectedUsers.value;
                isOverflown.value = !!element && element.scrollHeight > element.clientHeight;
            });
        });
        const store = useStore();
        const userId = computed(() => store.getters.session.id);
        const filteredUsers = computed(() => {
            const users = props.users;
            const emails = props.modelValue.map((user) => user.email);
            return users
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .filter((user) => user.id !== userId.value && !emails.includes(user.email));
        });
        const handleSelection = (selection) => {
            const selections = props.modelValue;
            selections.push(selection);
            emit('update:modelValue', selections);
        };
        const removeUser = (email) => {
            const selections = props.modelValue.filter((user) => user.email !== email);
            emit('update:modelValue', selections);
        };
        const handleSearchTerm = (value) => {
            emit('update:searchTerm', value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(UserMultiSelect, {
                    class: "max-w-150",
                    "search-term": __props.searchTerm,
                    size: __props.size,
                    users: _unref(filteredUsers),
                    "disallow-external-to-workspace": __props.disallowExternalToWorkspace,
                    "disallow-external-to-workspace-placeholder": __props.disallowExternalToWorkspacePlaceholder,
                    onSelection: handleSelection,
                    "onUpdate:searchTerm": handleSearchTerm
                }, null, 8, ["search-term", "size", "users", "disallow-external-to-workspace", "disallow-external-to-workspace-placeholder"]),
                _createElementVNode("ul", {
                    ref_key: "selectedUsers",
                    ref: selectedUsers,
                    class: _normalizeClass(["flex flex-col space-y-2 overflow-auto", { 'pr-2': isOverflown.value, 'max-h-64': __props.size === 'sm', 'max-h-36': __props.size === 'lg' }])
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue, (user) => {
                        return (_openBlock(), _createBlock(SelectedUser, {
                            key: user.email,
                            user: user,
                            onRemove: ($event) => (removeUser(user.email))
                        }, null, 8, ["user", "onRemove"]));
                    }), 128))
                ], 2)
            ]));
        };
    }
});
